export default __webpack_public_path__ + "static/media/TeamBuildingPlatform.1fbec6e1.svg";